import { render, staticRenderFns } from "./AboutNew.vue?vue&type=template&id=5b35dcc4&scoped=true"
import script from "./AboutNew.vue?vue&type=script&lang=ts"
export * from "./AboutNew.vue?vue&type=script&lang=ts"
import style0 from "./AboutNew.vue?vue&type=style&index=0&id=5b35dcc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b35dcc4",
  null
  
)

export default component.exports